angular.
module("dx.webapp.jobs").
controller("DxJobImportStudentsController", function JobImportStudentsController(
	$scope,
	$location,

	DX_JOB_METADATA_TYPE,
	dxApi,
	DX_URLS,
	DX_JOB_STATUS,
	dxSession,
	RoleTypeEnum,

	dxLocalize,
	DX_KEY_CODES
) {
	"use strict";

	var self = this;

	self.DX_JOB_STATUS = DX_JOB_STATUS;
	self.RoleTypeEnum = RoleTypeEnum;
	self.role = dxSession.getRole();

	self.duplicateStudents = [];
	self.deletedDuplicateStudents = [];
	self.loading = {
		jobErrors: true,
		imports: true,
	};

	self.importedStudentData = [];
	self.deletedStudents = [];
	self.importDataErrors = [];

	var jobStatusWatcher = $scope.$watch("vm.job.status", loadMetadata);

	function loadMetadata() {
		if (self.job.status === self.DX_JOB_STATUS.DONE) {
			if (self.job.taskCountSkipped) {
				dxApi.v1.jobs.metadata.get(self.job.id, DX_JOB_METADATA_TYPE.DUPLICATE).then(onDuplicateLoadSuccess, onDuplicateLoadFail);
			} else {
				self.loading.jobErrors = false;
			}

			if (self.job.getSuccessfulCount()) {
				dxApi.v1.jobs.metadata.get(self.job.id, DX_JOB_METADATA_TYPE.IMPORT).then(onImportLoadSuccess, onImportLoadFail);
			} else {
				self.loading.imports = false;
			}

			jobStatusWatcher();
		}
	}

	function onDuplicateLoadSuccess(response) {
		self.loading.jobErrors = false;
		 var jobErrors = response.data;

		for (var i = 0; i < jobErrors.length; i++) {
			if (jobErrors[i].data.deleted) {
				self.deletedDuplicateStudents.push(jobErrors[i]);
			} else {
				self.duplicateStudents.push(jobErrors[i]);
			}
		}
	}

	function onDuplicateLoadFail() {
		self.loading.jobErrors = false;
		self.errorMessages = dxLocalize.get("AccountManagerImports.Duplicate.LoadError");
	}

	function onImportLoadSuccess(response) {
		var importData = response.data;

		for (var i = 0; i < importData.length; i++) {
			var data = importData[i].data;

			switch (data.deleted) {
				case true:
					self.deletedStudents.push({
						id: parseInt(importData[i].objectId, 10),
						internalDeletion: data.internalDeletion,
					});
					break;
				case false:
					self.importedStudentData.push({
						id: importData[i].objectId,
						name: data.name,
						code: data.studentCode,
						email: data.email,
						created: data.created,
						spellcheckAllowed: data.spellcheckAllowed,
						textToSpeechAllowed: data.textToSpeechAllowed,
						extendedTimeSetting: data.extendedTimeSetting,
						usbAudioAllowed: data.usbAudioAllowed,
						immersiveReaderAllowed: data.immersiveReaderAllowed,
					});
					break;
				default:
					self.importDataErrors.push(importData[i].objectId);
			}
		}

		self.loading.imports = false;
	}

	function onImportLoadFail() {
		self.loading.imports = false;
		self.errorMessages = dxLocalize.get("AccountManagerImports.LoadError");
	}

	self.navigateToStudent = function navigateToStudent(id) {
		if (self.role.roleType === self.RoleTypeEnum.MASTER) {
			$location.path(DX_URLS.get("masterToolsStudentView", {id: id}));
		} else {
			$location.path(DX_URLS.get("student", {id: id}));
		}
	};

	self.onListRowKeyDown = function onListRowKeyDown(event, id) {
		if (event.keyCode !== DX_KEY_CODES.enter && event.keyCode !== DX_KEY_CODES.space) {
			return;
		}
		event.preventDefault();

		self.navigateToStudent(id);
	};

	loadMetadata();
});
